import React, { Component } from 'react';
import { Components } from 'botframework-webchat';
import { defaultStyle } from '../styles/defaultInputBoxStyles';
import '../styles/chatInput.scss';
import PropTypes from 'prop-types';
import setSendBox from 'botframework-webchat-core/lib/actions/setSendBox';

const { SendButton, SendTextBox } = Components;
class ChatSendBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendBoxValue: '',
      inputCharLimit: 250,
      isSendButtonDisabled: true,
      arrowMoved: false,
      mentionsOpened: false,
      showEmojis: this.props.emojiattach,
      file: null,
      userid: "",
      directline: null,
      resetShow: false,
      disableSend: true
    };
    this.inputRef = React.createRef();
    this.mouseClick = false;
    this.fileUploadInp = React.createRef();

  }

  handlePress = (value) => {
    if (value) {
      this.setState({ sendBoxValue: value });      
    }else{
      this.resetChatInput()
    }
  }

  handleEmoji = (emoji) => {
    if (emoji) {
      const smiley = String.fromCodePoint(parseInt (emoji, 16))
      const value = this.state.sendBoxValue + smiley;
      this.setState({ sendBoxValue: value });
      this.props.store.dispatch(setSendBox(value.trim()));      
    }
  }

  resetChatInput=()=>{
    this.setState({sendBoxValue: ''})
  }

  render() {
    return (
      <>
        <div>
          <div onChange={(e) => {
            this.handlePress(e.target.value)

          }} onKeyPress={(e) => { 
            if (e.key == 'Enter'){
              this.setState({ sendBoxValue: '' });
            }
          }} className={"webchat__send-box chat-inputbox-container"}
          >
            <div className={'chat-inputbox-wrapper webchat__send-box__main'}>
              <div className='inputbox-container'>
                <div className='inputbox-wrapper'>
                  <SendTextBox
                    value={this.state.sendBoxValue}
                    className='webchat__send-box-text-box'
                    style={defaultStyle}
                    maxlength={250}
                    placeholder='Type your message'
                  />
                  <div className={`input-box-btn`}>
                    <SendButton className={'webchat__send-box__button'} />
                  </div>
                </div>
                <div className='input-character-container'>
                  <span className='input-character'>
                    {' '}
                   
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

ChatSendBox.propTypes = {
  store: PropTypes.object,
};

export default ChatSendBox;